import React, { useState, useEffect } from 'react';
import { Input, Button, Table, Card, Col, Row, Checkbox,Space } from 'antd';

const GenericAddRemoveMultipleRecords = ({
  titleLeft,
  titleRight,
  dataSource,
  selectedKeys = [],
  onUpdateSelectedKeys,
  columnsLeft,
  columnsRight,
  searchFields = [],
}) => {
  const [filteredLeftData, setFilteredLeftData] = useState([]);
  const [filteredRightData, setFilteredRightData] = useState([]);
  const [tempLeftSelected, setTempLeftSelected] = useState([]);
  const [tempRightSelected, setTempRightSelected] = useState([]);
  const [selectAllLeft, setSelectAllLeft] = useState(false); // Track "Select All" state for left table
  const [selectAllRight, setSelectAllRight] = useState(false); // Track "Select All" state for right table
  const [loadingLeft, setLoadingLeft] = useState(true);
  const [loadingRight, setLoadingRight] = useState(true);
  const [searchTextLeft, setSearchTextLeft] = useState('');
  const [searchTextRight, setSearchTextRight] = useState('');

  useEffect(() => {
    setLoadingLeft(true);
    setLoadingRight(true);

    const leftData = dataSource.filter((item) => !selectedKeys.includes(item._id));
    const rightData = dataSource.filter((item) => selectedKeys.includes(item._id));

    setTimeout(() => {
      setFilteredLeftData(leftData);
      setFilteredRightData(rightData);
      setLoadingLeft(false);
      setLoadingRight(false);
    }, 500);
  }, [dataSource, selectedKeys]);

  const handleSearch = (searchText, isLeftSearch) => {
    const lowerText = searchText.toLowerCase();
    
    if (isLeftSearch) {
      if (searchText === '') {
        const leftData = dataSource.filter((item) => !selectedKeys.includes(item._id));
        setFilteredLeftData(leftData);
      } else {
        const filtered = dataSource.filter((item) =>
          !selectedKeys.includes(item._id) &&
          searchFields.some((field) => item[field]?.toLowerCase().includes(lowerText))
        );
        setFilteredLeftData(filtered);
      }
    } else {
      if (searchText === '') {
        const rightData = dataSource.filter((item) => selectedKeys.includes(item._id));
        setFilteredRightData(rightData);
      } else {
        const filtered = dataSource.filter((item) =>
          selectedKeys.includes(item._id) &&
          searchFields.some((field) => item[field]?.toLowerCase().includes(lowerText))
        );
        setFilteredRightData(filtered);
      }
    }
  };

  const handleSelect = (itemId, tempSelected, setTempSelected) => {
    setTempSelected((prev) =>
      prev.includes(itemId) ? prev.filter((id) => id !== itemId) : [...prev, itemId]
    );
  };

  const handleSelectAll = (isChecked, data, setTempSelected, setSelectAll) => {
    setTempSelected(isChecked ? data.map((item) => item._id) : []);
    setSelectAll(isChecked);
  };

  const handleMoveItems = (items, fromSelected, toSelectedSetter) => {
    const updatedSelectedKeys = fromSelected
      ? selectedKeys.filter((key) => !items.includes(key))
      : [...selectedKeys, ...items];
    onUpdateSelectedKeys(updatedSelectedKeys);
    setTempLeftSelected([]);
    setTempRightSelected([]);
    setSelectAllLeft(false);
    setSelectAllRight(false);
  };

  const handleSelectAllToggle = (isLeft) => {
    if (isLeft) {
      setSelectAllLeft(!selectAllLeft);
      handleSelectAll(!selectAllLeft, filteredLeftData, setTempLeftSelected, setSelectAllLeft);
    } else {
      setSelectAllRight(!selectAllRight);
      handleSelectAll(!selectAllRight, filteredRightData, setTempRightSelected, setSelectAllRight);
    }
  };

  return (
    <Row gutter={[16, 16]}>
      {/* Left Table */}
      <Col xs={24} md={12}>
        <Card title={titleLeft}>
          <Input.Search
            placeholder={`Search ${titleLeft}`}
            value={searchTextLeft}
            onChange={(e) => setSearchTextLeft(e.target.value)}
            onSearch={() => handleSearch(searchTextLeft, true)}
            enterButton
            style={{ marginBottom: 16, width: '100%' }}
          />
          <Space style={{ marginBottom: 16 }}>
          <Button
            type="primary"
            onClick={() => handleMoveItems(tempLeftSelected, false)}
            disabled={tempLeftSelected.length === 0}
            style={{ marginLeft: 16 }}
          >
            Add Selected
          </Button>
          </Space>
          <Table
            columns={[
              {
                title: (
                  <Checkbox
                    checked={selectAllLeft}
                    onChange={() => handleSelectAllToggle(true)}
                  />
                ),
                key: 'select',
                width: 80,
                render: (_, record) => (
                  <Checkbox
                    checked={tempLeftSelected.includes(record._id)}
                    onChange={() => handleSelect(record._id, tempLeftSelected, setTempLeftSelected)}
                  />
                ),
              },
              ...columnsLeft,
            ]}
            dataSource={filteredLeftData}
            rowKey="_id"
            pagination={false}
            scroll={{ y: 200 }}
            loading={loadingLeft}
          />
        </Card>
      </Col>

      {/* Right Table */}
      <Col xs={24} md={12}>
        <Card title={titleRight}>
          <Input.Search
            placeholder={`Search ${titleRight}`}
            value={searchTextRight}
            onChange={(e) => setSearchTextRight(e.target.value)}
            onSearch={() => handleSearch(searchTextRight, false)}
            enterButton
            style={{ marginBottom: 16, width: '100%' }}
          />
            <Space style={{ marginBottom: 16 }}>          
            <Button
            type="primary"
            danger
            onClick={() => handleMoveItems(tempRightSelected, true)}
            disabled={tempRightSelected.length === 0}
            style={{ marginLeft: 16 }}
          >
            Remove Selected
          </Button>
          </Space>
          <Table
            columns={[
              {
                title: (
                  <Checkbox
                    checked={selectAllRight}
                    onChange={() => handleSelectAllToggle(false)}
                  />
                ),
                key: 'remove',
                width: 80,
                render: (_, record) => (
                  <Checkbox
                    checked={tempRightSelected.includes(record._id)}
                    onChange={() => handleSelect(record._id, tempRightSelected, setTempRightSelected)}
                  />
                ),
              },
              ...columnsRight,
            ]}
            dataSource={filteredRightData}
            rowKey="_id"
            pagination={false}
            scroll={{ y: 200 }}
            loading={loadingRight}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default GenericAddRemoveMultipleRecords;
